export default "__VITE_ASSET__0Qv08H_Z__"